import bg from "../../assets/img/bg/bg-agency.png";

const Hero = () => {
  return (
    <section className="agency-hero" id="agency-hero">
      <div className="agency-hero-overlay">
        <div className="agency-hero-content">
          <h1 className="agency-hero-title">Toutes nos agences en France</h1>
          <p className="agency-hero-subtitle">
            Venez nous rencontrer dans l’une de nos agences et profitez <br />
            d’un entretien de recrutement entièrement personnalisé.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
